"use client";

import { useEffect } from "react";
import dispatchGoogleAnalyticsEvent, { gaEvents, gaFormatters } from "@/modules/analytics/google/dispatchGoogleAnalyticsEvent";
import { TrackingCallback, TrackingData } from "@growthbook/growthbook";

// Only fire tracking calls once per page load
const trackedExperiments = new Set<string>();

export const onExperimentView: TrackingCallback = (experiment, result) => {
    
    const trackingData = {
        feature: result.featureId ?? "",
        experimentId: experiment.key,
        variationId: result.key,
        hashAttribute: result.hashAttribute,
        hashValue: result.hashValue,
    }

    const props = {
        experimentId: trackingData.experimentId,
        variationId: trackingData.variationId,
        [trackingData.hashAttribute]: trackingData.hashValue,
    };

    const key = JSON.stringify(props);
    if (trackedExperiments.has(key)) return;
    trackedExperiments.add(key);

    // Send tracking call to analytics (GA4, Segment, etc.)
    dispatchGoogleAnalyticsEvent(
        gaEvents.GrowthBookExperiment,
        gaFormatters.growthbookExperiment(
            trackingData.experimentId,
            trackingData.variationId
        )
    )
};


export function GrowthBookTrackFlags({ data }: { data: TrackingData[] }) {
    useEffect(() => {
        data.forEach(({ experiment, result }) => {
            onExperimentView(experiment, result);
        });
    });

    return null;
}
